import { Subscription } from 'rxjs';
import { ConnectedPosition, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, ComponentRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { MapHlp } from 'src/lib/fliko/helpers/map.helper';
import { EmojiData } from 'src/app/shared/models/emoji.model';
import { EmojiInputListComponent } from './emoji-input-list/emoji-input-list.component';

import emojis from '../../../../../assets/emojis.json';

interface OverlayComp {
  overlay: OverlayRef;
  component: ComponentRef<EmojiInputListComponent>;
  subscription$: Subscription;
}

@Component({
  selector: 'app-emoji-input',
  templateUrl: './emoji-input.component.html',
  styleUrls: ['./emoji-input.component.scss']
})
export class EmojiInputComponent implements OnInit, OnDestroy {
  @Output() onSelect = new EventEmitter<EmojiData>();

  public emojisMap = new Map<string, EmojiData[]>();
  public lastSelected: EmojiData[] = [];

  public overlayRef: OverlayComp | null = null;

  public positions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'bottom' }
  ];

  @ViewChild('menuButton') button!: HTMLElement;

  constructor(private overlay: Overlay) {}

  ngOnInit(): void {
    this.emojisMap = new Map();
    const data = Array.from(emojis.data);
    data.forEach((e) => MapHlp.arrayMapAdd(this.emojisMap, e.categoryKey, e));
  }

  ngOnDestroy(): void {
    this.handleOverlay(null);
  }

  public showList(event: MouseEvent): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();

    if (!this.overlayRef) {
      const overlay = this.overlay.create({
        width: '500px',
        minHeight: '150px',
        positionStrategy: this.overlay.position().flexibleConnectedTo(this.button).withPositions(this.positions)
      });
      const subscription$ = new Subscription();
      subscription$.add(
        overlay.outsidePointerEvents().subscribe((event) => {
          // ? Check for open button click - to omit closing immediately after opening
          const target: Element = event.target as any;
          if (!target.classList.contains('emoji-button')) this.handleOverlay(null);
        })
      );
      const portalHost = new ComponentPortal(EmojiInputListComponent);
      const component = overlay.attach(portalHost);
      component.instance.initData(this.emojisMap, this.lastSelected);
      subscription$.add(component.instance.onSelect.subscribe((data) => this.handleOverlay(data, false)));
      this.overlayRef = { overlay, component, subscription$ };
    }
  }

  private handleOverlay(data: EmojiData | null, close: boolean = true): void {
    if (data) {
      this.onSelect.emit(data);
      if (!this.lastSelected.find((d) => d.name === data.name)) {
        this.lastSelected = ArrHlp.insert(this.lastSelected, data, 0).slice(0, 10);
      }
    }
    if (close) {
      this.overlayRef?.subscription$.unsubscribe();
      this.overlayRef?.overlay.detach();
      this.overlayRef?.overlay.dispose();
      this.overlayRef = null;
    }
  }
}
